import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Gifts.css";

const Gifts = () => {
  const [gifts, setGifts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uniqueCategories, setUniqueCategories] = useState(["All"]);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [activeGift, setActiveGift] = useState(null);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/gifts`)
      .then((response) => {
        setGifts(response.data);
        setLoading(false);

        // Assuming categories can be converted to integers for sorting
        const extractedCategories = new Set(
          response.data.map((gift) => parseInt(gift.category, 10))
        );
        const sortedCategories = Array.from(extractedCategories)
          .filter((category) => !isNaN(category))
          .sort((a, b) => a - b);

        // Prepend "All" and convert categories back to strings if necessary
        const categories = [
          "All",
          ...sortedCategories.map((category) => category.toString()),
        ];
        setUniqueCategories(categories);

        // Optionally, randomize gifts if "All" is initially selected
        if (selectedCategory === "All") {
          randomizeGifts(response.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching gifts:", error);
        setLoading(false);
      });

    // Function to handle the Escape key press
    const handleEscapeKeyPress = (event) => {
      if (event.key === "Escape") {
        setActiveGift(null);
      }
    };

    // Add event listener for keydown events
    document.addEventListener("keydown", handleEscapeKeyPress);

    // Clean up the event listener
    return () => {
      document.removeEventListener("keydown", handleEscapeKeyPress);
    };
  }, [selectedCategory]); // Be cautious with this dependency

  // Separate function to handle gifts randomization
  const randomizeGifts = (giftsData) => {
    const shuffledGifts = [...giftsData].sort(() => 0.5 - Math.random());
    setGifts(shuffledGifts);
  };

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    if (category === "All") {
      randomizeGifts(gifts);
    } else {
      // This ensures that upon selecting another category,
      // the gifts are filtered without being shuffled again.
      setGifts(gifts);
    }
  };

  const handleImageClick = (gift) => {
    setActiveGift(gift);
  };

  const closeOverlay = () => {
    setActiveGift(null);
  };

  // Filter gifts based on selected category
  const filteredGifts = gifts.filter(
    (gift) => selectedCategory === "All" || gift.category === selectedCategory
  );

  return (
    <div className="gifts-page">
      <div className="gifts-container">
        <div className="sidebar">
          <h4>Categories</h4>
          <ul>
            {uniqueCategories.map((category, index) => (
              <li key={index}>
                <label>
                  <input
                    type="radio"
                    name="category"
                    checked={selectedCategory === category}
                    onChange={() => handleCategoryChange(category)}
                  />
                  <span className="category-name">{category}</span>
                </label>
              </li>
            ))}
          </ul>
        </div>
        <div className="gifts">
          {loading ? (
            <div>Loading...</div>
          ) : (
            filteredGifts.map((gift) => (
              <div
                className="gift"
                key={gift.id}
                onClick={() => handleImageClick(gift)}
              >
                <img src={gift.photo_link} alt={gift.gift_name} />
                <div className="gift-details">
                  <h3>{gift.gift_name}</h3>
                  <p>Category: {gift.category}</p>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
      {activeGift && (
        <div className="overlay" onClick={closeOverlay}>
          <img
            src={activeGift.photo_link}
            alt={activeGift.gift_name}
            className="zoomed-image"
          />
        </div>
      )}
    </div>
  );
};

export default Gifts;
